import React from "react";
import { formatToken } from "../../utils/format";
import { TOKEN_SYMBOL } from "../../config/config";
import "./PackageCard.css";

export default function PackageCard({
  index, label, price, isActive, canActivate,
  ceiling, earned, remaining, pending,
  onActivate, onRetopup, loading, holdBal,
}) {
  const progress = ceiling && ceiling.gt(0)
    ? (parseFloat(earned || 0) / parseFloat(ceiling)) * 100
    : 0;

  return (
    <div className={`pkg-card ${isActive ? "pkg-active" : "pkg-inactive"}`}>
      <div className="pkg-header">
        <span className="pkg-label">{label}</span>
        <span className={`pkg-badge ${isActive ? "badge-active" : "badge-inactive"}`}>
          {isActive ? "Active" : "Inactive"}
        </span>
      </div>

      {isActive && (
        <>
          <div className="pkg-progress-section">
            <div className="pkg-progress-labels">
              <span>Earned: {formatToken(earned)}</span>
              <span>Ceiling: {formatToken(ceiling)}</span>
            </div>
            <div className="pkg-progress-bar">
              <div className="pkg-progress-fill" style={{ width: `${Math.min(progress, 100)}%` }} />
            </div>
            <div className="pkg-remaining">
              Remaining: {formatToken(remaining)} {TOKEN_SYMBOL}
            </div>
          </div>

          {holdBal !== undefined && !holdBal.isZero() && (
            <div className="pkg-hold">
              Auto Upgrade Hold Income: {formatToken(holdBal)} {TOKEN_SYMBOL}
            </div>
          )}

          {pending !== undefined && !pending.isZero() && (
            <div className="pkg-pending">
              Pending Share: {formatToken(pending)} {TOKEN_SYMBOL}
            </div>
          )}
        </>
      )}

      <div className="pkg-actions">
        {!isActive ? (
          <button className="btn-neon" onClick={() => onActivate(index)} disabled={loading || !canActivate}>
            {loading ? "Processing..." : canActivate ? "Activate" : "Locked"}
          </button>
        ) : (
          <button className="btn-neon btn-secondary" onClick={() => onRetopup(index)} disabled={loading}>
            {loading ? "Processing..." : "Re-Topup"}
          </button>
        )}
      </div>
    </div>
  );
}
